<template>
  <div>
    <nav-bar />
    <v-container class="mt-10 pt-5">
      <!-- Page Header ########################################### -->
      <v-container>
        <v-row align="end">
          <v-col>
            <div class="page-title">
              <a @click.stop="goToCouncilManagement"><v-icon class="mr-3">fal fa-arrow-left</v-icon></a>
              <h1>{{ moduleTitle }} de Conselho</h1>
            </div>
          </v-col>
        </v-row>
      </v-container>
      <v-form v-model="isFormValid">
        <v-container>
          <!-- Card-1 -->
          <v-card elevation="8">
            <!--card title-->
            <v-card-title class="pb-0">
              <v-container class="d-flex align-center justify-space-between">
                <span class="list-labels">Dados básicos</span>
                <div class="d-flex flex-row align-center">
                  <span class="list-labels">Ativo</span>
                  <v-switch class="ml-4" inset v-model="council.entityViewModel.active"></v-switch>
                </div>
              </v-container>
            </v-card-title>

            <!--card content-->
            <v-card-text class="py-0">
              <v-container py-0>
                <v-row>
                  <!-- avatar ###################################### -->
                  <v-col class="flex-shrink-0 flex-grow-0 pt-6">
                    <span class="d-flex align-center justify-center">
                      <v-avatar size="220" class="style-avatar flex-column justify-center" tile>
                        <div>
                          <v-icon @click="onPickFile()" size="35" class="clickable flex-grow-0"
                            color="var(--gray-light)">fas fa-image</v-icon>
                          <img :src="selectedFileContent" height="150" @click="onPickFile()" />
                          <input type="file" style="display: none" ref="fileInput" accept="image/*"
                            @change="onFilePicked" required />
                          <h6 class="tiny-label mt-2">LOGOTIPO</h6>
                        </div>
                      </v-avatar>
                    </span>
                  </v-col>
                  <!-- form dados básicos ###################################### -->
                  <v-col class="flex-grow-1">
                    <v-container fluid pa-0>
                      <v-row>

                        <v-col cols="12" md="6">
                          <v-select v-model="council.secretaryId" :items="secretaries" :item-text="secretaryName"
                            item-value="id" label="Secretaria vinculada" outlined hide-details="auto" required
                            :rules="[secretaryRule]" :disabled="saving"></v-select>

                        </v-col>
                        <v-col>
                          <div class="d-flex  flex-row align-center float-right">
                              <span class="list-labels">Registro Simplificado</span>
                              <v-switch class="ml-4" inset
                                v-model="council.simplifiedReceipt"></v-switch>
                            </div>

                        </v-col>
                      </v-row>
                      <v-row>
                        <v-col cols="12" md="6">
                          <v-text-field v-model="council.entityViewModel.name" label="Nome do Conselho" outlined
                            hide-details="auto" required :rules="[nameRule]" :disabled="saving"
                            maxlength="200"></v-text-field>
                        </v-col>
                        <v-col cols="12" md="6">
                          <v-text-field v-mask="['##.###.###/####-##']" v-model="council.entityViewModel.document"
                            label="CNPJ" outlined hide-details="auto" required :rules="[documentRule]"
                            :disabled="saving"></v-text-field>
                        </v-col>
                        <v-col cols="12" md="6">
                          <v-text-field v-model="council.entityViewModel.socialReason" label="Razão Social" outlined
                            hide-details="auto" required :rules="[socialReasonRule]" :disabled="saving"
                            maxlength="200"></v-text-field>
                        </v-col>
                        <v-col cols="12" md="6">
                          <v-select v-model="council.incentiveLawId" :items="incentiveLawList" item-text="name"
                            item-value="id" label="Lei de Incentivo" outlined hide-details="auto" required
                            :rules="[incentiveLawRule]" :disabled="saving"></v-select>
                        </v-col>
                      </v-row>
                      <!-- Não remover o botão, usado para quebrar o form no responsivo ################################ -->
                      <v-row>
                        <v-col>
                          <v-btn disabled depressed color="var(--feature)" dark rounded large class="px-12 op-0"
                            @click="showChangePassword = !showChangePassword">
                            <v-icon class="mr-3" small>fal fa-lock</v-icon>Alterar Senha
                          </v-btn>
                        </v-col>
                      </v-row>
                    </v-container>
                  </v-col>
                </v-row>
              </v-container>
            </v-card-text>
          </v-card>
        </v-container>

        <v-container v-if="council.signatureUrl">
          <!-- Card-1 -->
          <v-card elevation="8">
            <!--card title-->
            <v-card-title class="pb-0">
              <v-container class="d-flex align-center justify-space-between">
                <span class="list-labels">Assinatura</span>
              </v-container>
            </v-card-title>

            <!--card content-->
            <v-card-text class="py-0">
              <v-container py-0>
                <v-row>
                  <!-- avatar ###################################### -->
                  <v-col class="flex-shrink-0 flex-grow-0 pt-6">
                    <span class="d-flex align-center justify-center">
                      <img :src="council.signatureUrl" height="150" @click="onPickFile()" />
                    </span>
                  </v-col>
                </v-row>
              </v-container>
            </v-card-text>
          </v-card>
        </v-container>

        <!-- form address ###################################### -->
        <AddressWithGoogleMapsImage v-model="council.entityViewModel.addressViewModel" ref="address" />

        <!-- form data bank ###################################### -->
        <v-container>
          <v-card elevation="8">
            <!--card title-->
            <v-card-title>
              <v-container>
                <span class="list-labels">Dados Bancários</span>
              </v-container>
            </v-card-title>

            <!--card content-->
            <v-card-text class="mb-container">
              <v-container class="grid-list-sm">
                <v-row>
                  <v-col cols="12" md="7">
                    <v-container fluid pa-0>
                      <v-row class="mw-600">
                        <v-col cols="12" class="mw-320">
                          <v-select v-model="council.bankId" clearable label="Banco" outlined hide-details="auto"
                            :items="bankList" item-text="name" item-value="id"
                            @change="clearBankDataInformation"></v-select>
                        </v-col>
                      </v-row>
                      <v-row>
                        <v-col cols="12" md="6">
                          <v-text-field v-model="council.agency" label="Agência" v-mask="['####']" outlined
                            hide-details="auto" required :rules="[isAgencyValid]"
                            :disabled="!council.bankId"></v-text-field>
                        </v-col>
                        <v-col cols="12" md="4">
                          <v-text-field v-model="council.account" label="Conta Corrente" outlined hide-details="auto"
                            maxlength="10" :required="!!council.bankId" :rules="[isAccountValid]"
                            :disabled="!council.bankId"></v-text-field>
                        </v-col>
                        <v-col cols="12" md="2">
                          <v-text-field v-model="council.digit" maxlength="1" label="Dígito" outlined
                            hide-details="auto" :required="!!council.bankId" :rules="[isDigitValid]"
                            :disabled="!council.bankId"></v-text-field>
                        </v-col>
                      </v-row>
                      <v-row>
                        <v-col cols="12" md="6">
                          <v-text-field v-model="council.eCommerceCode" label="Número do convênio" outlined
                            v-mask="['#######']" persistent-hint hint="Qual o convênio utilizado no Banco?"
                            :required="!!council.referenceCode" :rules="[isECommerceCodeValid]"></v-text-field>
                        </v-col>
                        <v-col cols="12" md="6">
                          <v-text-field v-model="council.referenceCode" label="Nº Convênio Cobrança (Refran)" outlined
                            persistent-hint v-mask="['#################']" hint="Refran (17 dígitos)"
                            :required="!!council.eCommerceCode" :rules="[isReferenceCodeValid]"></v-text-field>
                        </v-col>
                      </v-row>
                    </v-container>
                  </v-col>
                  <v-col cols="12" md="5"> </v-col>
                </v-row>
              </v-container>
            </v-card-text>
          </v-card>
        </v-container>

        

        <!-- buttons float ###################################### -->
        <template>
          <v-footer fixed color="transparent" padless class="justify-center">
            <v-card elevation="6" class="pt-3 pb-4 px-4 footer-card">
              <v-btn color="secondary" rounded large depressed class="px-12 mr-1 white--text footer-border-left"
                @click="goToCouncilManagement" :loading="saving">Voltar</v-btn>
              <v-btn color="secondary" rounded large depressed class="px-12 ml-1 footer-border-right"
                @click="saveCouncil" :disabled="!canSave" :loading="saving">Salvar</v-btn>
            </v-card>
          </v-footer>
        </template>
      </v-form>
    </v-container>
  </div>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
import NavBar from "@/components/NavBar";
import Address from "@/scripts/models/address.model";
import EntityService from "@/scripts/services/entity.service";
import GeneralService from "@/scripts/services/general.service";
import CommonHelper from "@/scripts/helpers/common.helper";
import Routes from "@/router/names.js";
export default {
  name: "CouncilRegister",
  components: {
    NavBar
  },
  data: () => ({
    saving: false,
    secretaries: [],
    incentiveLawList: [],
    bankList: [{ id: "1", name: "Banco do Brasil" }],
    council: {
      id: 0,
      entityViewModel: {
        name: null,
        document: null,
        socialReason: null,
        active: true,
        addressViewModel: new Address()
      },
      logo: {
        name: "",
        contentType: "",
        content: ""
      },
      secretaryId: null,
      incentiveLawId: null,
      bankId: null,
      agency: null,
      account: null,
      digit: null,
      referenceCode: null,
      eCommerceCode: null
    },
    selectedFileContent: "",
    selectedFile: null,
    isFormValid: false,
    entityService: new EntityService(),
    generalService: new GeneralService(),
    moduleTitle: "Cadastro"
  }),
  computed: {
    ...mapGetters(["selectedCouncil"]),
    canSave() {
      return (
        this.isFormValid &&
        // !!this.council.logo.content &&
        // this.selectedFileContent &&
        (!!this.council.bankId || !!this.council.eCommerceCode) &&
        this.$refs &&
        this.$refs.address.isValid
      );
    },
    isAgencyValid() {
      if (!this.council.bankId) return true;
      return !!this.council.agency || "Digite a agência";
    },
    isAccountValid() {
      if (!this.council.bankId) return true;
      return !!this.council.account || "Digite a conta corrente";
    },
    isDigitValid() {
      if (!this.council.bankId) return true;
      return !!this.council.digit || "Digite o dígito";
    },
    isECommerceCodeValid() {
      if (!this.council.referenceCode) return true;
      return !!this.council.eCommerceCode || "Digite o número do convênio";
    },
    isReferenceCodeValid() {
      if (!this.council.eCommerceCode) return true;
      return !!this.council.referenceCode || "Digite o número Refran";
    }
  },
  created() {
    if (
      this.$route.params.councilId &&
      this.selectedCouncil &&
      this.selectedCouncil.id == this.$route.params.councilId
    ) {
      this.setCouncil(this.selectedCouncil);
    } else if (this.$route.params.councilId) {
      this.entityService
        .getCouncilById(this.$route.params.councilId)
        .then(this.getCouncilByIdCallBack);
    } else {
      this.setSelectedCouncil(null);
    }
    this.entityService
      .listAllActiveSecretaries()
      .then(result => (this.secretaries = result));
    this.generalService
      .listAllIncentiveLaws()
      .then(result => (this.incentiveLawList = result));
  },
  methods: {
    ...mapActions(["setSelectedCouncil"]),
    setCouncil(c) {
      this.moduleTitle = "Edição";
      this.council = { ...c };
      this.council.entityViewModel = { ...c.entityViewModel };
      this.council.entityViewModel.addressViewModel = {
        ...c.entityViewModel.addressViewModel
      };
      if (this.council.logo) {
        if (this.council.logo.url)
          this.selectedFileContent = this.council.logo.url;
        else
          this.selectedFileContent = `data:${this.council.logo.contentType};base64, ${this.council.logo.content}`;
      }
    },
    getCouncilByIdCallBack(data) {
      this.setCouncil(data);
    },
    saveCouncil() {
      this.saving = true;
      if (this.council.id > 0) {
        this.entityService
          .editCouncil(this.council, this.selectedFile)
          .then(this.savedCallback)
          .finally((this.saving = false));
      } else {
        this.entityService
          .createCouncil(this.council, this.selectedFile)
          .then(this.savedCallback)
          .finally((this.saving = false));
      }
    },
    savedCallback() {
      CommonHelper.swal("Success", "success", "Council successfully saved");
      this.goToCouncilManagement();
    },
    goToCouncilManagement() {
      this.$router.push({ name: Routes.app.CouncilManagement });
    },
    secretaryRule() {
      return !!this.council.secretaryId || "Selecione a secretaria vinculada";
    },
    nameRule() {
      return !!this.council.entityViewModel.name || "Digite o nome do conselho";
    },
    documentRule() {
      if (!this.council.entityViewModel.document)
        return "Digite o CNPJ do conselho";
      if (!CommonHelper.validateCNPJ(this.council.entityViewModel.document))
        return "CNPJ inválido";
      return true;
    },
    socialReasonRule() {
      return (
        !!this.council.entityViewModel.socialReason ||
        "Digite a razão social do conselho"
      );
    },
    incentiveLawRule() {
      return !!this.council.incentiveLawId || "Selecione a lei de incentivo";
    },
    clearBankDataInformation() {
      if (!this.council.bankId) {
        this.council.agency = null;
        this.council.account = null;
        this.council.digit = null;
      }
    },
    secretaryName(secretary) {
      return secretary.entityViewModel.name;
    },
    onPickFile() {
      if (!this.saving) this.$refs.fileInput.click();
    },
    onFilePicked(event) {
      const files = event.target.files;
      this.selectedFile = files[0];
      let fileName = files[0].name;
      if (fileName.lastIndexOf(".") <= 0) {
        return alert("Por favor adicione um arquivo válido");
      }
      const fileReader = new FileReader();
      fileReader.addEventListener("load", () => {
        this.selectedFileContent = fileReader.result;
      });
      fileReader.readAsDataURL(files[0]);
    }
  }
};
</script>
